import OptionsQuestion from './OptionsQuestion';

export default OptionsQuestion;
